/* eslint-disable no-param-reassign */
import produce, { current } from 'immer';
import initialState from '../initialState';
var processingSettingsSaved = produce(function (draft, action) {
  var settingName = action.payload.settingName;
  draft.originalProcessing[settingName] = current(draft.processing[settingName]);
}, initialState);
export default processingSettingsSaved;